import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";

import Navbar from "./components/layout/Navbar";
import Footer from "./components/layout/Footer";
import Home from "./pages/Home";
import Technology from "./pages/Technology";
import Industries from "./pages/Industries";
import About from "./pages/About";
import Contact from "./pages/Contact";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

const Layout = ({ children }) => (
    <div className="App min-h-screen flex flex-col">
        <Navbar />
        <div className="flex-1">{children}</div>
        <Footer />
    </div>
);

function App() {
    return (
        <BrowserRouter>
            <ScrollToTop />
            <Toaster
                position="bottom-right"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0A1220",
                        border: "1px solid rgba(0, 229, 255, 0.25)",
                        color: "#fff",
                    },
                }}
            />
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/technology" element={<Technology />} />
                    <Route path="/industries" element={<Industries />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="*" element={<Home />} />
                </Routes>
            </Layout>
        </BrowserRouter>
    );
}

export default App;
